import {capitalizeFirst} from '@wandb/weave/core/util/string';
import React from 'react';

import {useIsAdminModeActiveAndIsNotLocalEnv} from '../../../util/admin';
import {useIsWorkspaceTemplatePrivilegeEnabled} from '../../WorkspaceTemplate/useIsWorkspaceTemplateEnabled';
import {useWorkspaceTemplateDrawerContext} from '../../WorkspaceTemplate/WorkspaceTemplateDrawerContextProvider';
import {DISABLED_WB_ADMIN_ACTION_TOOLTIP_CONTENT} from '../utils';
import {OverflowMenuItem} from './OverflowMenu';

const UPGRADE_PLAN_TOOLTIP_CONTENT =
  'Upgrade your plan in order to access this feature.';

export const WorkspaceTemplateOverflowMenuItem = () => {
  const isWorkspaceTemplateAccountPrivilegeEnabled =
    useIsWorkspaceTemplatePrivilegeEnabled();

  const {
    openWorkspaceTemplateDrawer,
    workspaceTemplateMode,
    isWorkspaceTemplateActionDisplayed,
  } = useWorkspaceTemplateDrawerContext();

  const {isButtonDisabled, tooltipContent} = useTooltipContent(
    isWorkspaceTemplateAccountPrivilegeEnabled
  );

  if (!isWorkspaceTemplateActionDisplayed) {
    return null;
  }

  const displayName = `${capitalizeFirst(
    workspaceTemplateMode
  )} personal workspace template`;

  return (
    <OverflowMenuItem
      displayName={displayName}
      icon="settings-parameters"
      data-dd-action-name="Personal workspace template"
      onSelect={openWorkspaceTemplateDrawer}
      disabled={isButtonDisabled}
      tooltipContent={tooltipContent}
    />
  );
};

const useTooltipContent = (
  isWorkspaceTemplateAccountPrivilegeEnabled: boolean
) => {
  const wbAdminUsingPowers = useIsAdminModeActiveAndIsNotLocalEnv();

  // do not allow wb admins on saas to use this feature if admin powers are on
  if (wbAdminUsingPowers) {
    return {
      isButtonDisabled: true,
      tooltipContent: DISABLED_WB_ADMIN_ACTION_TOOLTIP_CONTENT,
    };
  }

  if (!isWorkspaceTemplateAccountPrivilegeEnabled) {
    return {
      isButtonDisabled: true,
      tooltipContent: UPGRADE_PLAN_TOOLTIP_CONTENT,
    };
  }

  return {
    isButtonDisabled: false,
    tooltipContent: undefined,
  };
};
